import { Container, Grid, Typography } from "@mui/material"
import ProductCard from "../components/product-card"

const RecentlyAddedPage = () => {

    return (
        <>
            <Container sx={{ padding: '10px' }}>
                <Typography variant="h5"> Recently Added</Typography>
                <Grid container>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                    <Grid item xs={2}><ProductCard /></Grid>
                </Grid>

            </Container>
        </>
    )
}

export default RecentlyAddedPage